const AccessIndex = () => import("@/components/Admin/Realm/AccessIndex");
const AddRealm = () => import("@/components/Admin/Realm/AddRealm");
const AddRealmUser = () => import("@/components/Admin/Realm/AddRealmUser");
const UpdateRealmUser = () => import("@/components/Admin/Realm/UpdateRealmUser");

const routes = [
  {
    name: "ManageAccess",
    path: "/manage-access",
    component: AccessIndex,
    meta: {
      title: "Manage Access",
      sidebar: true
    }
  },
  {
    name: "AddRealm",
    path: "/add-realm",
    component: AddRealm,
    meta: {
      title: "Add Realm",
      sidebar: true
    }
  },
  {
    name: "AddRealmUser",
    path: "/add-realm-user",
    component: AddRealmUser,
    meta: {
      title: "Add Realm User",
      sidebar: true
    }
  },
  {
    name: "UpdateRealmUser",
    path: "/update-realm-user/:id",
    component: UpdateRealmUser,
    meta: {
      title: "Update Realm User",
      sidebar: true
    }
  }
];

export default routes;
